
import React, { useEffect, useState } from 'react'
import { Col, Container, Offcanvas, Row } from 'react-bootstrap'
import Loading from './Loading'
import axios from 'axios'
import OrderDetailsContainer from '../components/OrderDetailsContainer/OrderDetailsContainer'
import { useNavigate, useParams } from 'react-router-dom'
import { useDispatch, useSelector } from 'react-redux'
import AddHeader from '../components/AddHeader/AddHeader'
import FilterContainer from '../components/FilterContainer/FilterContainer'

function OrderDetails() {
  const [loading, setLoading] = useState(false)
  const [show, setShow] = useState(false);
  const { id } = useParams()
  const userinfo = useSelector((state) => state);
  const navigate = useNavigate();
  const dispatch = useDispatch()
  const { currentLocal } = useSelector((state) => state.currentLocal);
  const { list: orders } = useSelector((state) => state.orders);

  const order = orders.filter((item) => item?.id == id)

  console.log(orders);

  return (
    loading ?
      <Loading />
      :
      <div className='outlit_bg px-4'>
        <AddHeader
          title={currentLocal.home.OrderDetails}
          text={""}
        />
        <FilterContainer
          exportexcel={false}
          searchState={false}
        />
        <Container>
          <Row className='mt-4'>
            <p className='fw-bold'>
              {currentLocal.home.OrderDetails}
            </p>
          </Row>
          <Row>
            <Col md={12}>
              <OrderDetailsContainer
                order={order}
              />
            </Col>
          </Row>
        </Container>
      </div>
  )
}

export default OrderDetails